function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';

/**
 * A hook for detecting hovering (mouse enter and mouse leave) over an element
 * @param options UseHoverOptions
 * @returns UseHoverReturn
 */
var useHover = function useHover() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delayEnter = options.delayEnter,
    delayEnter = _options$delayEnter === void 0 ? 0 : _options$delayEnter,
    _options$delayLeave = options.delayLeave,
    delayLeave = _options$delayLeave === void 0 ? 0 : _options$delayLeave;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  var mouseEnterTimer;
  var mouseOutTimer;
  return {
    hovered: hovered,
    hoverProps: {
      onMouseEnter: function onMouseEnter() {
        clearTimeout(mouseOutTimer);
        mouseEnterTimer = setTimeout(function () {
          return setHovered(true);
        }, delayEnter);
      },
      onMouseLeave: function onMouseLeave() {
        clearTimeout(mouseEnterTimer);
        mouseOutTimer = setTimeout(function () {
          return setHovered(false);
        }, delayLeave);
      }
    },
    setHovered: setHovered
  };
};
export { useHover };